/* eslint-disable promise/avoid-new */
const getBase64Image = async (
  imageUrl: string,
): Promise<string | ArrayBuffer | null> => {
  const imageFromUrl = await fetch(imageUrl);
  const imageBlob: Blob = await imageFromUrl.blob();

  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = (): void => resolve(reader.result);
    reader.onerror = (): void =>
      resolve('/static/img/avatar-examinee-default.png');
    reader.readAsDataURL(imageBlob);
  });
};

export default getBase64Image;
